import { FC } from "react";
import React, { useState } from "react";
import {
  Input,
  Button,
  Form,
  message,
  Flex,
  Card,
  Modal,
  Checkbox,
} from "antd";
import { useMutation } from "@tanstack/react-query";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { queryKeys } from "../../../services/react-query/queryKeys";
import DeleteModal from "../../common/DeleteModal";
import { deleteCommission } from "../../../network/commission";
import { useIntl } from "react-intl";

interface DeleteCategoryProps {
  visible: boolean;
  onClose: () => void;
  data: any; // Define the editCategoryData prop
  team_member_id: number; // Define the editCategoryData prop
}

const DeleteCommission: FC<DeleteCategoryProps> = ({
  visible,
  onClose,
  data,
  team_member_id,
}) => {
  const intl = useIntl();
  return (
    <DeleteModal
      visible={visible}
      onClose={onClose}
      onDelete={deleteCommission}
      data={team_member_id}
      optionalParam2={data?.id}
      confirmationHeader={intl.formatMessage({
        id: "DeleteCommissionWarning",
        defaultMessage: "هل انت متأكد من حذف هذه العمولة للعضو ؟",
      })}
      confirmationText={intl.formatMessage({
        id: "DeleteCommissionWarningDesc",
        defaultMessage:
          "سيتم حذف العمولة و لن يتمكن عضو الفريق من الحصول عليها بعد الآن",
      })}
      queryKey={queryKeys.listCommission}
      successMessage="Commission deleted successfully"
    />
  );
};

export default DeleteCommission;
